import React from 'react';
import logo from '../assets/logo.png';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from '@fortawesome/free-solid-svg-icons';
import $ from 'jquery';

const Topbar = ({children}) => (
    <section id="top" className="page-block">{children}</section>
);

const doActive = (e) => {
    $(`#Navigation li a`).removeClass('active');
    $(`#Navigation li:nth-child(${parseInt(e.target.id)+1}) a`).addClass('active');
    return;
}

const Header = () => {
    let href = window.location.href.split('/');
    let link = href[href.length-1];

    return(
        <div className="row">
            <div className="col-xs-12 col-lg-3 left-side">
                <div className="col-xs-12 text-center mb-2">
                    <img src={logo} className="img_logo mt-2" alt='project logo' style={{height:'100px', width:'100px'}} />
                </div>
            </div>
            <div className="col-xs-12 col-sm-9 main-content" style={{padding:'0px'}}>
                <div className="comp-bg  d-none d-md-block d-sm-block">
                    <FontAwesomeIcon icon={faBars} size='2x' className="menuIcon" /> 
                    <span className="appName">SME HIGH GROWTH<span> PROGRAMME</span></span>
                    <ul>
                        <li><a href="/introduction" className={link == "introduction" ?"list-group-item text-danger": ''}>Registration</a></li>
                        <li><a href="/guidelines" className={link == "guidelines" ?"list-group-item text-danger": ''}>Guidelines</a></li>
                        <li><a href="/faq" className={link == "faq" ?"list-group-item text-danger": ''}>FAQs</a></li>
                    </ul>
                </div>
                <div className="comp-bg d-lg-none d-md-none d-sm-none text-center">
                    <span className="appName">SME High Growth <br /><span>Programme</span></span>
                    <ul>
                        <li><a href="/introduction" className={link == "introduction" ?"list-group-item text-danger": ''}>Register</a></li>
                        <li><a href="/guidelines" className={link == "guidelines" ?"list-group-item text-danger": ''}>Guide</a></li>
                        <li><a href="/faq" className={link == "faq" ?"list-group-item text-danger": ''}>FAQs</a></li>
                        <li><a href="/exclusion" className={link == "exclusion" ?"list-group-item text-danger": ''}>Exlusion</a></li>
                    </ul><br /><br />
                </div>
            </div>
        </div>
    )
};

Topbar.Header = Header;

export default Topbar;
export { Topbar, Header };